import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faLocationDot } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-row">
        <div className="footer-section footer-column-large">
          <h2 className="footer-heading">WHO WE ARE</h2>
          <div className="footer-dotted-line-large"></div>
          <div className="footer-columns">
            <div className="footer-column">
              <a href="https://outreachdigitalmarketing.com/about-us/" className="footer-link">About Us</a>
              <a href="https://outreachdigitalmarketing.com/marketing-check-up/" className="footer-link">Marketing Check Up</a>
              <a href="https://outreachdigitalmarketing.com/reviews/" className="footer-link">Reviews</a>
              <a href="https://outreachdigitalmarketing.com/contact-us/" className="footer-link">Contact Us</a>
            </div>
            <div className="footer-column">
              <a href="https://outreachdigitalmarketing.com/website-development/" className="footer-link">Website Development</a>
              <a href="https://outreachdigitalmarketing.com/los-angeles-seo-company/" className="footer-link">Los Angeles Seo Company</a>
              <a href="https://outreachdigitalmarketing.com/blog/" className="footer-link">Blog</a>
            </div>
          </div>
        </div>
        <div className="footer-section">
          <h2 className="footer-heading">OUR SERVICES</h2>
          <div className="footer-dotted-line-small"></div>
          <a href="https://outreachdigitalmarketing.com/digital-marketing-solutions/" className="footer-link">Digital Marketing Solutions</a>
          <a href="https://outreachdigitalmarketing.com/seo-services-for-local-business/" className="footer-link">SEO Services For Local Business</a>
          <a href="https://outreachdigitalmarketing.com/seo-services-for-small-business/" className="footer-link">SEO Services For Small Business</a>
          <a href="https://outreachdigitalmarketing.com/seo-agency-for-local-business/" className="footer-link">SEO Agency For Local Business</a>
        </div>
        <div className="footer-section">
          <h2 className="footer-heading">CONTACT US</h2>
          <div className="footer-dotted-line-small"></div>
          <div className="footer-contact">
        <FontAwesomeIcon icon={faPhone} className="footer-icon" />
        <a href="tel:8056246646" className="footer-phone">805-624-6646</a>
        </div>
          <div className="footer-location">
            <FontAwesomeIcon icon={faLocationDot} className="footer-icon1" />
            <span className="footer-address">
              30721 Russell Ranch Road Suite 140 <br />
              Westlake Village, CA 91362
            </span>
          </div>
          <div className="footer-social-icons">
            <a href="https://www.facebook.com/OutreachLocalMarketing/" target="_blank" rel="noopener noreferrer">
                <img src="/fb.png" alt="Facebook" className="social-icon" />
            </a>
            <a href="https://twitter.com/Outreach_Local" target="_blank" rel="noopener noreferrer">
                <img src="/tt.png" alt="Twitter" className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/in/david-gersh-8b624449/" target="_blank" rel="noopener noreferrer">
                <img src="/ld.png" alt="LinkedIn" className="social-icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom-line"></div>
      <div className="footer-bottom">
        <span className="footer-copyright">
          Copyright © 2025. All rights reserved outreachdigitalmarketing.com
        </span>
        <div className="footer-policies">
          <a href="https://outreachdigitalmarketing.com/terms-conditions/" className="footer-policy-link">Terms & Conditions</a>
          <span className="separator">|</span>
          <a href="https://outreachdigitalmarketing.com/privacy-policy/" className="footer-policy-link">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
